export function postalCodeReducer( state = '', action ){
    switch( action.type ){
        case "SET_POSTAL_CODE": return action.payload
        default: return state
    }
}
export function streetReducer( state = '', action ){
    switch( action.type ){
        case "SET_STREET": return action.payload
        default: return state
    }
}

export function streetNumberReducer( state = '', action ){
    switch( action.type ){
        case "SET_STREET_NUMBER": return action.payload
        default: return state
    }
}

export function complementReducer( state = '', action ){
    switch( action.type ){
        case "SET_COMPLEMENT": return action.payload
        default: return state
    }
}

export function stateLocationReducer( state = '', action ){
    switch( action.type ){
        case "SET_STATE_LOCATION": return action.payload
        default: return state
    }
}

export function cityLocationReducer( state = '', action ){
    switch( action.type ){
        case "SET_CITY_LOCATION": return action.payload
        default: return state
    }
}
export function districReducer( state = '', action ){
    switch( action.type ){
        case "SET_DISTRICT": return action.payload
        default: return state
    }
}



// WEBPACK FOOTER //
// ./src/components/parts/address-component/reducers.js